import React from "react";
import "./UserPalette.css";
import LanguageSwitcher from "./LanguageSwitcher.mjs";
import {Row, Col} from "reactstrap";
import CustomerIcon from "./CustomerIcon.mjs";
import appLib from "../libs/appLib.mjs";

const G = window.glob;

const UserPalette = class extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            appinfo: G.getStatus('AppInfo'),
            player: G.getStatus('Player')
        };
        this.uid = G.generateUid('UserPalette');
    }

    componentDidMount() {
        G.register('AppInfo', (ai) => {
            this.setState({appinfo: ai});
        }, this.uid);
        G.register('Player', (p) => {
            this.setState({player: p});
        }, this.uid);
    }

    componentWillUnmount() {
        G.deregister(this.uid);
    }

    render() {
        const ac = this.state.appinfo ? "full" : "minimal";
        return (
            <div className={"UserPalette " + ac} id={this.uid} key={ac}>
                <LanguageSwitcher key={"LanguageSwitcher"}/>
                {this.state.appinfo?.icon || this.state.player ? (
                    <Row key={"row2"} className={"row2"}>
                        {this.state.appinfo?.icon ? (
                            <Col
                                title={this.state.appinfo.desc}
                            >
                                <CustomerIcon key={"CustomerIcon"} info={this.state.appinfo}/>
                            </Col>
                        ) : ''}
                        {this.state.player ? (
                            <Col
                                className={"UserIcon"}
                                title={G.label('Logout') + ': ' + this.state.player.name}
                                onClick={() => {
                                    appLib.logout();
                                }}
                            >
                                {this.state.player.icon}
                            </Col>
                        ) : ''}
                    </Row>
                ) : ''}
            </div>
        );
    }
}

export default UserPalette;